import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Changement ici : grid-cols-5 pour que les 5 blocs tiennent sur la ligne */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          
          {/* 1. About */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src="/logo-header.png" 
                alt="Nature Cévennes" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-sm leading-relaxed">
              Hébergements et activités de pleine nature au cœur des Gorges du Tarn et du Parc National des Cévennes.
            </p>
          </div>

          {/* 2. Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Liens rapides</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/hebergements/gite-la-draille" className="hover:text-[#afab53] transition-colors">
                  Gîte La Draille
                </Link>
              </li>
              <li>
                <Link to="/hebergements/camping-la-pegue" className="hover:text-[#afab53] transition-colors">
                  Camping La Pègue
                </Link>
              </li>
              <li>
                <Link to="/activites" className="hover:text-[#afab53] transition-colors">
                  Activités
                </Link>
              </li>
              <li>
                <Link to="/sejours" className="hover:text-[#afab53] transition-colors">
                  Séjours
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#afab53] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* 3. Contact - La Draille */}
          <div>
            <h3 className="text-white font-semibold mb-4">La Draille</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#afab53]" />
                <span>465 route de Florac<br />48150 Meyrueis</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#afab53]" />
                <span>04 66 45 65 37</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#afab53]" />
                <span>06 19 43 50 39</span>
              </li>
            </ul>
          </div>

          {/* 4. Contact - Fremyc */}
          <div>
            <h3 className="text-white font-semibold mb-4">Fremyc</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#afab53]" />
                <span>Place Sully<br />48150 Meyrueis</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#afab53]" />
                <span>06 58 13 48 48</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#afab53]" />
                <span>06 81 61 63 50</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-[#afab53]" />
                <span className="break-all">info@nature-cevennes.com</span>
              </li>
            </ul>
          </div>

          {/* 5. Contact - La Pègue */}
          <div>
            <h3 className="text-white font-semibold mb-4">La Pègue</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#afab53]" />
                <span>Route de Millau, Gorge de la Jonte<br />48150 Meyrueis</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#afab53]" />
                <span>06 58 13 48 48</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#afab53]" />
                <span>06 81 61 63 50</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-[#afab53]" />
                <span className="break-all">info@nature-cevennes.com</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Nature Cévennes. Tous droits réservés.
          </p>
          <div className="flex gap-4">
            <a href="https://www.facebook.com/ladraille.gite" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#afab53] transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;